import { c as _c } from "react/compiler-runtime";
const PILLARS: [title: string, copy: string][] = [['Create', 'Make people want it'], ['Convert', 'Turn intent into purchases'], ['Compound', 'Earn loyalty + advocacy']];

/**
 * Create / Convert / Compound strip. Full-width orange band beneath the hero.
 */
export function DemandPillarsBlock() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section className="border-b-2 border-gray-950 bg-[#ff5a36] text-gray-950"><div className="mx-auto grid max-w-[1440px] grid-cols-1 sm:grid-cols-3">{PILLARS.map(_temp)}</div></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(t0, index) {
  const [title, copy] = t0;
  return <div key={title} className={`px-6 py-6 sm:px-8 lg:px-12 ${index > 0 ? "border-t-2 border-gray-950 sm:border-l-2 sm:border-t-0" : ""}`}><p className="text-3xl font-black tracking-tight text-white">{title}.</p><p className="mt-1 font-bold text-[#211d4f]">{copy}</p></div>;
}